import { createContext } from 'react';

interface WysiwygContextInterface {
  apiUrl: string;
  envVars: {
    allowDirectVideoLinks: boolean;
  };
}

export const WysiwygContext = createContext<WysiwygContextInterface>({
  apiUrl: '',
  envVars: {
    allowDirectVideoLinks: false,
  },
});
